<template>
  <div class="h-full rounded-lg flex flex-col gap-2">
    <div class="flex justify-center items-center gap-1 self-start">
      <button
        style="background-color: var(--button)"
        v-show="nao_estatico && permissionByTipo"
        class="btn"
        @click="triggerAction({ action: 'create_tipo' })"
      >
        <i
          class="fa-solid fa-circle-plus fa-2xl"
          style="color: var(--icon)"
        ></i>
        <div style="white-space: nowrap; color: var(--label)">Novo</div>
      </button>

      <button
        style="background-color: var(--button)"
        v-show="nao_estatico && rowSelected"
        class="btn"
        @click="updateItem(formData)"
      >
        <i class="fa-solid fa-edit fa-2xl" style="color: var(--icon)"></i>
        <div style="color: var(--label)">Atualizar</div>
      </button>

      <HistoricoObjetoButton
        v-if="rowSelected && historicoModelName"
        :model-name="historicoModelName"
        :objeto-id="formData.id"
        :modelo-label="tipo"
        variant="btn"
        icon-only
      />
    </div>

    <!-- Form Section -->
    <div
      v-show="(nao_estatico && rowSelected) || criarNovo"
      class="flex flex-col items-center p-1 gap-1"
    >
      <div class="flex items-center p-1 gap-1">
        <label for="nome" class="text-[var(--text)] text-sm" style="color: var(--label)"
          >Nome:</label
        >
        
        <!-- 'Rejeição' => textarea, else input -->
        <textarea
          v-if="tipo === 'Rejeição'"
          v-model="formData.nome"
          class="text-sm rounded-md p-1 outline-none"
          :class="{ 'input-required': !formData.nome }"
          placeholder="Nome do tipo"
        ></textarea>
        <input
          v-else
          type="text"
          v-model="formData.nome"
          class="text-sm rounded-md p-1 outline-none"
          :class="{ 'input-required': !formData.nome }"
          placeholder="Nome do tipo"
        />

        <!-- Show Perfis for 'Utilizador' -->
        <button v-if="tipo === 'Utilizador'" class="btn" @click="show_perfis">
          Mostrar Perfis
        </button>

        <!-- 'Notificação' => color input -->
        <div v-if="tipo === 'Notificação'" class="flex gap-1 items-center">
          <label for="color" class="text-[var(--text)] text-sm">Cor:</label>
          <color-input v-model="selectedColor" />
          <!-- Preview circle -->
          <!-- <div
            :style="{ backgroundColor: selectedColorCSS }"
            class="w-6 h-6 rounded-full"
          ></div> -->
        </div>

        <!-- 'Directorias' or 'Variáveis' => valor -->
        <label
          v-if="tipo === 'Directorias' || tipo === 'Variáveis' || tipo === 'Variável Subcliente'"
          for="valor"
          class="text-[var(--text)] text-sm"
        >
          Valor:
        </label>
        <input
          v-if="tipo === 'Directorias' || tipo === 'Variáveis' || tipo === 'Variável Subcliente'"
          type="text"
          v-model="formData.valor"
          class="text-sm rounded-md p-1 outline-none"
          :class="{ 'input-required': !formData.valor }"
          placeholder="Valor"
        />

        <!-- 'Serviço' => abreviatura -->
        <input
          v-if="tipo === 'Serviço'"
          type="text"
          v-model="formData.abreviatura"
          class="text-sm rounded-md p-1 outline-none"
          :class="{ 'input-required': !formData.abreviatura }"
          placeholder="abreviatura"
        />

        <!-- 'Rejeição' extra fields -->
        <label v-if="tipo === 'Rejeição'" class="text-[var(--text)] text-sm"
          >Lei:</label
        >
        <textarea
          v-if="tipo === 'Rejeição'"
          v-model="formData.lei"
          class="text-sm rounded-md p-1 outline-none"
        ></textarea>

        <label v-if="tipo === 'Rejeição'" class="text-[var(--text)] text-sm"
          >Letra:</label
        >
        <input
          v-if="tipo === 'Rejeição'"
          type="text"
          v-model="formData.letra"
          maxlength="5"
          class="text-sm rounded-md p-1 outline-none w-16"
          placeholder="Letra"
        />

        <div v-if="tipo === 'Rejeição'" class="flex gap-2 items-center">
          <p class="text-[var(--text)]">Familia:</p>
          <p class="text-[#ff9b05]">
            {{ formData.familia ? formData.familia.nome : "N/A" }}
          </p>
          <button
            class="fa-solid fa-pen-to-square text-2xl"
            style="color: #ff9b05"
            @click="openDialog('familia')"
          ></button>
        </div>

        <div v-if="tipo === 'Separador'" class="flex gap-2 items-center">
          <p class="text-[var(--text)]">Produto:</p>
          <p class="text-[#ff9b05]">
            {{ formData.produto ? formData.produto.produto : "N/A" }}
          </p>
          <button
            class="fa-solid fa-pen-to-square text-2xl"
            style="color: #ff9b05"
            @click="openDialog('produto')"
          ></button>
        </div>

        <!-- Save button if new -->
        <div>
          <button
            v-if="!rowSelected"
            class="btn"
            @click="registerItem(formData)"
          >
            Salvar
          </button>
        </div>
      </div>

      <div v-if="showPerfis"></div>
    </div>

    <!-- Chrome picker (optional) if you also have it) -->
    <!-- <chrome-picker v-if="selectedColor" v-model="selectedColor" /> -->

    <!-- Tables / Pagination -->
    <div
      class="flex flex-col gap-4 overflow-y-auto scrollbar-thin scrollbar-tema"
    >
      <div class="w-full flex flex-col gap-2">
        <AppTable
          :visibility="show_perfil_form"
          :show="true"
          :table_data="perfis"
          table_title="Perfis"
          @row-clicked="select_perfil"
          @close="close_table"
        />

        <AppTablePagination
          visibility="true"
          :show="true"
          :table_title="tipo"
          @row-clicked="select_tipo"
          @close="close_table"
          @update="this.refresh = !this.refresh"
          :refresh="refresh"
          :urlString="urlString"
          :filterData="filterData"
          :order_by="order_by"
          :page_size="page_size"
        />
      </div>
    </div>

    <!-- DialogLite for selecting e.g. Familia -->
    <DialogLite
      v-if="dialog"
      :propsData="dialogProps"
      @close="closeDialog"
      @return-data="returnData"
    />
  </div>
</template>

<script>
import axios from "axios";
import { toast } from "vue3-toastify";
import AppTablePagination from "@/components/tablePagination/tablePagination.vue";
import AppTable from "@/components/tables/table.vue";
import AppButton from "@/components/updated/button.vue";
import DialogLite from "@/components/dialog/dinamicDialog_lite.vue";
import permissionMixin from "@/permissionMixin.js";
import ColorInput from "vue-color-input"; // <-- If using 'vue-color-input'
import AppPerfilForm from "@/components/perfil/perfilForm.vue";
import { id as loggedID } from "@/extraData";
import { requestLock } from '@/utils/requestLock.js';
import HistoricoObjetoButton from "@/components/historico/HistoricoObjetoButton.vue";

export default {
  mixins: [permissionMixin],
  name: "appTipo",
  components: {
    AppTablePagination,
    AppTable,
    AppButton,
    DialogLite,
    ColorInput,
    AppPerfilForm,
    HistoricoObjetoButton,
  },
  props: {
    tipo: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      baseURl: process.env.VUE_APP_URL_BASE,
      urlString: "",
      filterData: {},
      refresh: false,
      rowSelected: false,
      formData: {},
      criarNovo: false,
      show_table: true,
      showPerfis: false,
      show_perfil_form: false,
      perfis: [],
      permissionByTipo: false,
      dialog: false,
      dialogProps: {
        title: "Familias",
        entity: "familia",
      },
      currentEntity: null,
      order_by: "",
      page_size: 10,
      // The color model from vue-color-input (HSL)
      selectedColor: {
        h: 0,
        s: 0,
        l: 0,
        a: 1,
      },
      permissions: [
        { Utilizador: "C0015" },
        { Cliente: "C0030" },
        { Viatura: "C0016" },
        { Zona: "C0017" },
        { IVA: "C0032" },
        { Contacto: "C0018" },
        { Valencia: "C0033" },
        { Armazem: "C0019" },
        { Tarefa: "C0034" },
        { Tarefa: "C0034" },
        { Separador: "C0034" }, // Colocar codigo correto
        { Serviço: "C0020" },
        { Artigo: "C0035" },
        { Marca: "C0036" },
        { Pagamento: "C0022" },
        { Prazo: "C0037" },
        { Moeda: "C0023" },
        { Documento: "C0038" },
        { Movimento: "C0024" },
        { Ticket: "C0039" },
        { Notificação: "C0025" },
        { Medida: "C0040" },
        { Ação: "C0015" },
        { Orçamento: "C0026" },
        { Tipologia: "C0041" },
        { Relatório: "C0027" },
        { Area: "C0042" },
        { Repositório: "C0028" },
        { Prioridade: "C0043" },
        { Rejeição: "C0029" },
        { Variáveis: "C0021" },
        // Mudar codigo de variaveis subcliente
        { VariavelSubcliente : "C0021" },
        { ModoContato: "C0021" },
        { Contrato: "C0021" },
        { Directorias: "C0031" },
        { Permissão: "C0061" },
        { Proposta: "C0077" }, // New Proposta tipo
        { EstadoProposta: "C0078" }, // New EstadoProposta tipo
        { EstadoOrcamento: "C0081" }, // New EstadoOrcamento tipo
        { CondiçõesOrçamento: "C0084" }, // New CondiçõesOrçamento tipo
        { EstadoEncomenda: "C0085" }, // New EstadoEncomenda tipo
        { EstadoCompra: "C0085" }, // New EstadoCompra tipo
        { EstadoArmazemLocal: "C0085" }, // New EstadoArmazemLocal tipo
        { Encomenda: "C0087" }, // New Encomenda tipo
        { EstadoValidação: "C0090" }, // New EstadoValidação tipo
        { Negocio: "C0026" }, // New Negocio tipo
      ],
    };
  },
  computed: {
    nao_estatico() {
      // Certain tipos are read-only
      if (
        this.tipo === "Viatura" ||
        this.tipo === "Armazem" ||
        this.tipo === "Movimento" ||
        this.tipo === "Cliente" ||
        this.tipo === "Pagamento"
      ) {
        return false;
      }
      return true;
    },
    processedTipo() {
      if (this.tipo === "Notificação") return "notificacao";
      if (this.tipo === "Serviço") return "servico";
      if (this.tipo === "Orçamento") return "orcamento";
      if (this.tipo === "Relatório") return "relatorio";
      if (this.tipo === "Repositório") return "repositorio";
      if (this.tipo === "Rejeição") return "rejeicao";
      if (this.tipo === "Variáveis") return "variaveis";
      if (this.tipo === "Ação") return "acao";
      if (this.tipo === "EstadoOrçamento") return "estadoorcamento";
      if (this.tipo === "CondiçõesOrçamento") return "condicoesorcamento";
      if (this.tipo === "EstadoValidação") return "estadovalidacao";
      if (this.tipo === "Variável Subcliente") return "variaveltemplate";
      if (this.tipo === "EstadoArmazemLocal") return "estadoarmazemlocal";
      return this.tipo;
    },
    // If vue-color-input is in HSL, display it as HSLA in the preview
    selectedColorCSS() {
      const { h, s, l, a } = this.selectedColor;
      return `hsla(${h}, ${s * 100}%, ${l * 100}%, ${a})`;
    },
    // Nome exato da classe do modelo Django (Historico.model_name é
    // model_class.__name__ — ver HistoricoMiddleware) para cada "tipo" desta
    // tela. Mapeado explicitamente em vez de derivado de urlString porque a
    // capitalização não segue um padrão único (tp + PascalCase na maioria,
    // mas DiretoriaSistema/VariavelSistema/VariavelSubcliente fogem à regra).
    // Se o tipo não estiver aqui, o botão de histórico simplesmente não aparece.
    historicoModelName() {
      const map = {
        Utilizador: "tpUtilizador",
        Cliente: "tpCliente",
        Viatura: "tpViatura",
        Zona: "tpZona",
        IVA: "tpIva",
        Contacto: "tpContacto",
        Valencia: "tpValencia",
        Armazem: "tpArmazem",
        Tarefa: "tpTarefa",
        Separador: "tpSeparador",
        Serviço: "tpServico",
        Artigo: "tpArtigo",
        Marca: "tpMarca",
        Pagamento: "tpPagamento",
        Prazo: "tpPrazo",
        Moeda: "tpMoeda",
        Documento: "tpDocumento",
        Movimento: "tpMovimento",
        Ticket: "tpTicket",
        Notificação: "tpNotificacao",
        Medida: "tpMedida",
        Orçamento: "tpOrcamento",
        Tipologia: "tpTipologia",
        Relatório: "tpRelatorio",
        Area: "tpArea",
        Repositório: "tpRepositorio",
        Prioridade: "tpPrioridade",
        Rejeição: "tpRejeicao",
        Directorias: "DiretoriaSistema",
        Variáveis: "VariavelSistema",
        "Variável Subcliente": "VariavelSubcliente",
        ModoContato: "tpModoContato",
        Contrato: "tpContrato",
        Ação: "tpAcao",
        Proposta: "tpProposta",
        EstadoProposta: "tpEstadoProposta",
        EstadoOrçamento: "tpEstadoOrcamento",
        CondiçõesOrçamento: "tpCondicoesOrcamento",
        EstadoEncomenda: "tpEstadoEncomenda",
        EstadoCompra: "tpEstadoCompra",
        EstadoArmazemLocal: "tpEstadoArmazemLocal",
        Encomenda: "tpEncomenda",
        EstadoValidação: "tpEstadoValidacao",
        // "Negocio" aqui é o Tipo de Negócio (tpNegocio) — não confundir com
        // o modelo Negocio (o próprio negócio/deal).
        Negocio: "tpNegocio",
      };
      return map[this.tipo] || null;
    },
  },
  watch: {
    // Every time the user changes color in the color picker
   selectedColor(newVal) {
      // ✅ Only update color for Notificação tipo
      if (this.tipo === 'Notificação') {
        this.formData.cor = this.hslToHex(
          newVal.h,
          newVal.s * 100,
          newVal.l * 100
        );
      }
    },
     tipo(newVal) {
      this.formData = {};
      this.setUrlString();
      this.rowSelected = false; 
      this.criarNovo = false;
      
      // ✅ Reset color when changing tipo
      this.selectedColor = { h: 0, s: 0, l: 0, a: 1 };
    },
  },
  created() {
    this.permissionByTipo = this.checkPermissions(this.tipo);
    this.setUrlString();
    this.get_perfis();
  },
  methods: {
    setUrlString() {
      // Map your tipo to an API path
      const tipo = this.processedTipo.toLowerCase();
      const tipoPaths = {
        directorias: "diretoriasistema",
        variaveis: "variavelsistema",
        variaveltemplate: "variaveltemplate",
        notificacao: "tpnotificacao",
        servico: "tpservico",
        orcamento: "tporcamento",
        relatorio: "tprelatorio",
        repositorio: "tprepositorio",
        rejeicao: "tprejeicao",
        acao: "tpacao",
        utilizador: "tputilizador",
        viatura: "tpviatura",
        separador: "tpseparador",

        // ... add your own ...
      };
      this.urlString = tipoPaths[tipo] || `tp${tipo}`;
    },
    checkPermissions(tipo) {
      console.log("Checking permissions for:", tipo);
      const permission = this.permissions.find(
        (p) => Object.keys(p)[0] === tipo
      );
      if (permission && permission[tipo] !== undefined) {
        console.log("Permission found:", permission[tipo]);
        return this.validPermission(permission[tipo]);
      }
      return false;
    },
    showToast(msg) {
      toast.error(msg, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    },
    checkForm(data) {
      if (!data.nome) {
        this.showToast(`O nome é obrigatório`);
        return false;
      }
      if (
        (this.tipo === "Variáveis" || this.tipo === "Directorias" || this.tipo === "Variável Subcliente") &&
        !data.valor
      ) {
        this.showToast(`Preencha todos os campos`);
        return false;
      }
      if (this.tipo === "Utilizador" && !data.perfil_id) {
        this.showToast(`Selecione um perfil`);
        return false;
      }
      return true;
    },
    show_perfis() {
      this.showPerfis = true;
      this.show_perfil_form = true;
    },
    close_perfil() {
      this.show_perfil_form = false;
    },
    select_perfil(data) {
      this.formData.perfil_id = data.id;
    },
    close_table() {
      this.show_table = false;
      this.show_perfil_form = false;
    },
    // Convert HSL => Hex
    hslToHex(h, s, l) {
      l /= 100;
      const a = (s * Math.min(l, 1 - l)) / 100;
      const f = (n) => {
        const k = (n + h / 30) % 12;
        const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * color)
          .toString(16)
          .padStart(2, "0");
      };
      return `#${f(0)}${f(8)}${f(4)}`.toUpperCase();
    },
    // Convert Hex => HSL
    hexToHsl(hexColor) {
      if (hexColor.startsWith("#")) {
        hexColor = hexColor.slice(1);
      }
      const r = parseInt(hexColor.slice(0, 2), 16) / 255;
      const g = parseInt(hexColor.slice(2, 4), 16) / 255;
      const b = parseInt(hexColor.slice(4, 6), 16) / 255;

      const max = Math.max(r, g, b);
      const min = Math.min(r, g, b);
      let h, s;
      let l = (max + min) / 2;

      if (max === min) {
        h = s = 0; // achromatic
      } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;
          case g:
            h = (b - r) / d + 2;
            break;
          case b:
            h = (r - g) / d + 4;
            break;
        }
        h /= 6;
      }
      return {
        h: h * 360,
        s: s * 100,
        l: l * 100,
      };
    },
    // Build full path for GET/POST/PUT/DELETE
    checkUrl(method) {
      const baseApiUrl = `${this.baseURl}/api/v1/`;
      const methodPaths = {
        get: "",
        post: "/registrar",
        put: "/editar",
        delete: "/eliminar",
      };
      const methodSuffix = methodPaths[method] || "";
      return `${baseApiUrl}${this.urlString}${methodSuffix}/`;
    },
    async get_perfis() {
      try {
        // Server-side filtered endpoint (utilizador_id = -1, no permissao join) — much lighter
        // than GET /api/v1/perfil/, which serializes every Permissao row for nothing.
        const response = await axios.get(`${this.baseURl}/api/v1/perfil/utilizador-neg1/`);
        this.perfis = response.data.data.map((perfil) => {
          delete perfil.utilizador_id;
          return perfil;
        });
      } catch (error) {
        console.error("Error fetching perfis:", error);
      }
    },
    triggerAction(action) {
      if (action.action === "create_tipo") {
        this.rowSelected = false;
        this.criarNovo = true;
        this.showPerfis = false;
        this.formData = {};
      }
    },
    async registerItem(formData) {
      return await requestLock.execute(`create-tipo-${this.tipo}`, async () => {
        if (!this.checkForm(formData)) return;
        const url = this.checkUrl("post");
        try {
          const response = await axios.post(
            `${url}`,
            formData
          );
          if (response.status >= 200 && response.status < 300) {
            toast.success(`${this.processedTipo} criado com sucesso!`, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 1000,
            });
            this.formData = {};
            this.refresh = !this.refresh;
          }
        } catch (error) {
          console.error("Error creating item:", error);
          toast.error(
            `Erro ao criar ${this.processedTipo}: ${
              error.response?.data?.message ?? ""
            }`,
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: false,
            }
          );
        }
        this.criarNovo = false;
      });
    },
    // Called when user clicks a row in <AppTablePagination />
    select_tipo(data) {
      this.rowSelected = true;
      this.formData = data;
      this.showPerfis = false;
      console.log("Selected tipo:", data);

      // If data.cor is a hex, convert to HSL for the color picker
      if (this.tipo === 'Notificação' && data.cor) {
        const { h, s, l } = this.hexToHsl(data.cor);
        this.selectedColor = {
          h,
          s: s / 100,
          l: l / 100,
          a: 1,
        };
      } else {
        // ✅ Reset color for other tipos
        this.selectedColor = { h: 0, s: 0, l: 0, a: 1 };
      }
    },
    async updateItem(formData) {
      return await requestLock.execute(`update-tipo-${this.tipo}-${formData.id}`, async () => {
        if (!this.checkForm(formData)) return;
        const url = this.checkUrl("put");
        try {
          const response = await axios.put(
            `${url}${formData.id}/`,
            formData,
            { headers: { "Content-Type": "application/json" } }
          );
          if (response.status >= 200 && response.status < 300) {
            toast.success(`${this.processedTipo} atualizado com sucesso!`, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 1000,
            });
            this.formData = {};
            this.refresh = !this.refresh;
          }
        } catch (error) {
          toast.error(
            `Erro ao atualizar ${this.processedTipo}: ${
              error.response?.data?.message || ""
            }`,
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: false,
            }
          );
        }
        this.rowSelected = false;
      });
    },
    async deleteItem(formData) {
      const url = this.checkUrl("delete");
      try {
        const response = await axios.delete(
          `${url}${formData.id}/`
        );
        if (response.status >= 200 && response.status < 300) {
          this.refresh = !this.refresh;
          toast.success(`${this.processedTipo} Eliminado com sucesso!`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        }
      } catch (error) {
        console.error("Error deleting item:", error);
        toast.error(`Erro ao eliminar ${this.processedTipo}`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      }
      this.rowSelected = false;
      this.formData = {};
    },
    openDialog(entity) {
      this.dialog = true;
      this.currentEntity = entity;
      this.dialogProps.entity = entity;
      if (entity === "familia") {
        this.dialogProps.title = "Familias";
        this.dialogProps.url = "familia";
      } else if (entity === "produto") {
        this.dialogProps.title = "Produtos";
        this.dialogProps.url = "produto";
      }
    },
    returnData(data) {
      // This is from DialogLite
      if (this.currentEntity === "familia") {
        this.formData.familia = data.data;
        this.formData.familia_id = data.data.id;
      } else if (this.currentEntity === "produto") {
        this.formData.produto = data.data;
        this.formData.produto_id = data.data.id;
      }
      this.dialog = false;
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.red-border {
  background-color: rgba(176, 88, 88, 0.664);
}
.scrollbar-thin {
  scrollbar-width: thin;
}
.scrollbar-orange::-webkit-scrollbar {
  width: 8px;
}
.scrollbar-orange::-webkit-scrollbar-thumb {
  background-color: orange;
  border-radius: 4px;
}

.scrollbar-tema {
  scrollbar-width: thin;
  scrollbar-color: var(--scroll) transparent;
}
</style>
